(function (exports) {
    "use strict";
    
    var ROLE_ACCOUNT_ADMIN = "AccountAdmin";
    
    function getDecodedRole(jwt_token) {
        return jwt_decode(jwt_token).role;
    }
    
    exports.isAccountAdmin = function (jwt_token) {
        var decoded_role = getDecodedRole(jwt_token);
        return (decoded_role === ROLE_ACCOUNT_ADMIN || $.inArray(ROLE_ACCOUNT_ADMIN , decoded_role) > -1)
    }

}(typeof exports === "undefined" ? this.Role = {} : exports));


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/js/role.jasset
 ** module id = 995
 ** module chunks = 0
 **/